// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 263) return "static/chunks/263-5b40a355e6f61c38.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"749":"e83a3ac0d03f9e12","880":"9457522b66453936"}[chunkId] + ".js";
};